import { Actions } from './Constants'

export const ReportErrorAction = (message: string, display: 'toast' | 'inline' | 'none' = 'none') => ({
    type: Actions.Errors.ReportApiError,
    error: { errorMessage: message },
    errorDisplay: display
})
